import React, { useEffect } from 'react';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import AssessmentsOverviewList from './AssessmentsOverviewList';

function ActiveAssessmentsOverviewList(): React.JSX.Element {
    const { filterByStatus } = useAssessmentsOverviewContext();
    useEffect(() => {
        filterByStatus(AssessmentStatuses.Active);
    }, []);

    return <AssessmentsOverviewList />;
}

export default ActiveAssessmentsOverviewList;
